export const RESALE_CONTROLS_ENABLED = false;

export const RESALE_COMING_SOON_MESSAGE = 'Secondary-market controls are coming soon.';

export const RESALE_OPTION = Object.freeze({
  NONE: 'no_resell',
  HIGHER: 'higher_offers_only',
  ALL: 'allow_all_offers',
});

export const RESALE_OPTION_VALUES = Object.freeze(Object.values(RESALE_OPTION));

export const RESALE_OPTION_CONFIG = Object.freeze([
  {
    value: RESALE_OPTION.NONE,
    label: 'No resell option',
    description: 'Keep resale disabled. Only you will see the artwork in offers.',
  },
  {
    value: RESALE_OPTION.HIGHER,
    label: 'Higher offers only',
    description: 'Allow offers above your purchase price. Lower bids are blocked.',
  },
  {
    value: RESALE_OPTION.ALL,
    label: 'Allow all offers',
    description: 'Allow collectors to submit offers of any amount.',
  },
]);

export function isValidResaleOption(value) {
  return RESALE_OPTION_VALUES.includes(value);
}

const RESELL_STATUS_TO_OPTION = Object.freeze({
  no_offers: RESALE_OPTION.NONE,
  higher_only: RESALE_OPTION.HIGHER,
  all_offers: RESALE_OPTION.ALL,
});

const OPTION_TO_RESELL_STATUS = Object.freeze({
  [RESALE_OPTION.NONE]: null,
  [RESALE_OPTION.HIGHER]: 'higher_only',
  [RESALE_OPTION.ALL]: 'all_offers',
});

export function mapResellStatusToOption(resellEligibility = {}) {
  if (!resellEligibility || typeof resellEligibility !== 'object') {
    return RESALE_OPTION.NONE;
  }
  if (!resellEligibility.value) {
    return RESALE_OPTION.NONE;
  }

  const status = typeof resellEligibility.status === 'string'
    ? resellEligibility.status.trim()
    : '';
  return RESELL_STATUS_TO_OPTION[status] ?? RESALE_OPTION.ALL;
}

export function buildResellEligibilityPayload(option = RESALE_OPTION.NONE) {
  if (option === RESALE_OPTION.NONE) {
    return { value: false, status: null };
  }
  const status = OPTION_TO_RESELL_STATUS[option] ?? 'all_offers';
  return {
    value: true,
    status,
  };
}
